  // Un SEUL observateur pour toute la page, même si « DS — Media » est répété
// des dizaines de fois : le drapeau global évite d'en créer un par section.
//
// Pourquoi ne pas se contenter de loading="lazy" : le seuil natif du
// navigateur se déclenche trop près de l'écran pour un lecteur Vimeo, qui a
// ensuite besoin d'une seconde pour démarrer. On anticipe donc de 1400px —
// environ un écran et demi d'avance — sans pour autant tout charger d'un coup.
(function () {
  if (window.__dsMediaEarly) { return; }
  window.__dsMediaEarly = true;

  function boot(el) {
    if (el.dataset.dsDone) { return; }
    el.dataset.dsDone = '1';
    if (el.dataset.dsSrc) { el.src = el.dataset.dsSrc; return; }
    if (el.tagName === 'IMG') {
      // Repasser en eager force le téléchargement immédiat, même si l'image
      // est encore hors champ.
      el.loading = 'eager';
      if (el.fetchPriority !== undefined) { el.fetchPriority = 'high'; }
      return;
    }
    if (el.tagName === 'VIDEO') {
      el.preload = 'auto';
      try { el.load(); } catch (e) {}
      var p = el.play();
      if (p && p.catch) { p.catch(function () {}); }
    }
  }

  function start() {
    var els = document.querySelectorAll(
      '[data-ds-src], .ds-media img[loading="lazy"], video.ds-media__video'
    );
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { boot(els[i]); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { boot(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '1400px 0px' });
    for (var j = 0; j < els.length; j++) { io.observe(els[j]); }
  }

  // ── Format réel des vidéos Vimeo / YouTube ────────────────────────────────
  // Le cadre est en 16:9 par défaut. Une vidéo verticale s'y retrouvait
  // minuscule, centrée entre deux bandes vides. On demande ses dimensions à
  // l'oEmbed du service et on règle la hauteur du cadre dessus. La réponse est
  // gardée en mémoire pour la session : une seule requête par vidéo.
  function ratios() {
    var cadres = document.querySelectorAll('[data-ds-ratio-auto]');
    for (var i = 0; i < cadres.length; i++) { ratio(cadres[i]); }
  }

  function ratio(cadre) {
    var url = cadre.getAttribute('data-ds-ratio-auto');
    if (!url || cadre.dataset.dsRatioDone) { return; }
    cadre.dataset.dsRatioDone = '1';

    var cle = 'ds-ratio:' + url;
    var garde = null;
    try { garde = sessionStorage.getItem(cle); } catch (e) {}
    if (garde) { cadre.style.setProperty('--ds-embed-ratio', garde); return; }

    var api = url.indexOf('youtu') > -1
      ? 'https://www.youtube.com/oembed?format=json&url='
      : 'https://vimeo.com/api/oembed.json?url=';
    fetch(api + encodeURIComponent(url))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.width || !d.height) { return; }
        var pct = (d.height / d.width * 100).toFixed(2) + '%';
        cadre.style.setProperty('--ds-embed-ratio', pct);
        try { sessionStorage.setItem(cle, pct); } catch (e) {}
      })
      .catch(function () {});   // pas de réponse : le 16:9 par défaut reste
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); ratios(); });
  } else {
    start();
    ratios();
  }
})();
